/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

function plural(n: number): number {
  if (n === 1) return 1;
  return 5;
}

export default [
  'ml',
  [
    ['AM', 'PM'],
    ,
  ],
  ,
  [
    ['ഞ', 'തി', 'ചൊ', 'ബു', 'വ്യാ', 'വെ', 'ശ'],
    [
      'ഞായർ', 'തിങ്കൾ', 'ചൊവ്വ', 'ബുധൻ', 'വ്യാഴം',
      'വെള്ളി', 'ശനി'
    ],
    [
      'ഞായറാഴ്\u200cച', 'തിങ്കളാഴ്\u200cച',
      'ചൊവ്വാഴ്ച', 'ബുധനാഴ്\u200cച',
      'വ്യാഴാഴ്\u200cച', 'വെള്ളിയാഴ്\u200cച',
      'ശനിയാഴ്\u200cച'
    ],
    ['ഞാ', 'തി', 'ചൊ', 'ബു', 'വ്യാ', 'വെ', 'ശ']
  ],
  [
    ['ഞാ', 'തി', 'ചൊ', 'ബു', 'വ്യാ', 'വെ', 'ശ'],
    [
      'ഞായർ', 'തിങ്കൾ', 'ചൊവ്വ', 'ബുധൻ', 'വ്യാഴം',
      'വെള്ളി', 'ശനി'
    ],
    [
      'ഞായറാഴ്\u200cച', 'തിങ്കളാഴ്\u200cച',
      'ചൊവ്വാഴ്\u200cച', 'ബുധനാഴ്\u200cച',
      'വ്യാഴാഴ്\u200cച', 'വെള്ളിയാഴ്\u200cച',
      'ശനിയാഴ്\u200cച'
    ],
    ['ഞാ', 'തി', 'ചൊ', 'ബു', 'വ്യാ', 'വെ', 'ശ']
  ],
  [
    [
      'ജ', 'ഫെ', 'മാ', 'ഏ', 'മെ', 'ജൂൺ', 'ജൂ', 'ഓ', 'സെ', 'ഒ',
      'ന', 'ഡി'
    ],
    [
      'ജനു', 'ഫെബ്രു', 'മാർ', 'ഏപ്രി', 'മേയ്',
      'ജൂൺ', 'ജൂലൈ', 'ഓഗ', 'സെപ്റ്റം', 'ഒക്ടോ',
      'നവം', 'ഡിസം'
    ],
    [
      'ജനുവരി', 'ഫെബ്രുവരി', 'മാർച്ച്',
      'ഏപ്രിൽ', 'മേയ്', 'ജൂൺ', 'ജൂലൈ', 'ഓഗസ്റ്റ്',
      'സെപ്റ്റംബർ', 'ഒക്\u200cടോബർ', 'നവംബർ',
      'ഡിസംബർ'
    ]
  ],
  ,
  [
    ['ക്രി.മു.', 'എഡി'], ,
    [
      'ക്രിസ്\u200cതുവിന് മുമ്പ്',
      'ആന്നോ ഡൊമിനി'
    ]
  ],
  0, [0, 0], ['d/M/yy', 'y, MMM d', 'y, MMMM d', 'y, MMMM d, EEEE'],
  ['h:mm a', 'h:mm:ss a', 'h:mm:ss a z', 'h:mm:ss a zzzz'],
  [
    '{1} {0}',
    ,
    ,
  ],
  ['.', ',', ';', '%', '+', '-', 'E', '×', '‰', '∞', 'NaN', ':'],
  ['#,##,##0.###', '#,##0%', '¤#,##0.00', '#E0'], '₹', 'ഇന്ത്യൻ രൂപ', plural
];
